import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { FrontOffService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hostelstudent',
  templateUrl: './hostelstudent.component.html',
  styleUrls: ['./hostelstudent.component.scss'],
   providers:[FrontOffService,AppGlobals,MasterService]
})
export class HostelstudentComponent implements OnInit 
{

   studentarr:any[];
    depts:any[];
    catgories:any[];
   
    @ViewChild('dt') table: any;
    closeResult: string;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
     private modalRef1: NgbModalRef;
    classes:any=[];
    sections:any=[];
    bloodgp:any=[];
    objfrm:any={};
    castecats:any=[];
    arrnotif:any=[];
    subcomb:any=[];
    oprtype:string;
    filtcatgory:any[];
    arhouse:any=[];
    aylist:any[];
    arpayopt:any=[];
    arfeequota1:any=[];
    arfeequota:any=[];
    arfeequotatp:any=[];
    arfeequotahs:any=[];
    armot:any=[];
    arrcourse:any=[];
    objstudent:any;
    admdash:any={};
    arrmtongue:any=[];
    objregdata:any={};
    objtcinfo:any={};
    arrstudoctype:any=[];
    stuclass:any=[];
    stuclassnew:any=[];
    stucourse:any=[];
    stufee:any=[];
    stuid;
    alclnew:boolean=true;
    alcrnew:boolean=true;
    defctype:any;
    catwiseissued:any=[];
    arrstatus=[{name:'Active'},{name:'Inactive'},{name:'Old'}];
    arropted=[{name:'Yes'},{name:'No'}];
    arrscst=[{name:'SC'},{name:'ST'},{name:'NO'}];
  
    arrcerftypes:any=[];
    arrformats:any=[];
  brdt:any;
      arrclass:any[]=[];
  arrclass1:any[]=[];
  arrcourse1:any[]=[];
  stucoursenew:any=[]
   
    //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
    tab=1;
    tab1=1;
    selcat:any=0;
    verifiedstatus:any;
    genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
    statuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'},{value:'Old',name:'Old'}];
  
    fileToUpload: File = null;
  
  fData: FormData = new FormData;
  dcid:any=0;
  arrstudoc:any=[];
  disuploadbtn=true;
  objbulkfilter:any={};
  arrfields:any=[];
  arrstulist:any=[];
  objfieldsel:any={};
  arrinst:any=[];
  defclass:any=0;
  defcorse:any=0;
  defsec:any='0';
  defstat='Active';
  studentarr1:any=[];
  arrsections:any=[];
  arrbatch:any=[];
  instype:any='';
  objfeesum:any={};
  arrfeerecs:any=[];
  arrinsext: any;
  arrinsinr: any;
  masclid:any;
  srtxt:any='';

  constructor(private http: HttpClient, private mservice:MasterService,private fservice: FrontOffService,private modalService: NgbModal,private apglobal:AppGlobals) {}

  ngOnInit(): void {
    this.selhostelstudent();
    this.masbloodgroup();
    this.sel_hosinstitute();
  }

  onsearchstudents()
  {
    if (this.srtxt.length>2)
    {
    this.searchstudents(this.masclid,this.srtxt);
    }
    else
    {
this.searchstudents(this.masclid,'');
    }
  }

openmemdialog(content,formdata,cmd) {
  // console.log("formdata",formdata);

  this.oprtype=cmd;
  if(cmd=='insert')
  {
    this.objregdata={};
    this.objregdata.stuid=0;
    this.objregdata.stunm='';
    // this.objregdata.ayid=this.aylist[0].ayid;
    this.objregdata.hstuid=0;
    this.objregdata.msclid=this.arrinst.filter(x=>x.intype=='E')[0].msclid;
   
    this.objregdata.dob=this.apglobal.getdatetoday();
    this.objregdata.gender='Male';
    this.objregdata.bgid='1';
    
    this.objregdata.subcaste='.';
    this.objregdata.stumobile='';
    this.objregdata.stuemail='';
    this.objregdata.fatnm='';
    this.objregdata.fatemail='';
    this.objregdata.fatprof='';
    this.objregdata.fatedu='';
    this.objregdata.fatmobile='';
   


    
    this.objregdata.address='';
    this.objregdata.city='';
    this.objregdata.pin='';
   

    // this.objregdata.addt=this.apglobal.getdatetoday();
    this.objregdata.vldt=this.apglobal.getdatetoday();
     this.objregdata.clnm='';
    this.objregdata.crnm='';
    this.objregdata.scnm='';
    this.objregdata.usid='';
    this.objregdata.oprtype=cmd;
   
    
  }
  else if (cmd=='update')
  {
    this.objregdata=formdata;
     this.objregdata.oprtype=cmd;
    // debugger
//     let localmodref=this.modalRef1;
// localmodref.close();
    // this.getstudentdata('s_id',formdata);
    // this.objstudent=formdata;
    // this.objstudent.oprtype=cmd;

  }
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }

    if (this.modalService.hasOpenModals())
   {
    document.body.style.removeProperty('padding-right');
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
 
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
        //  this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
    
  
}

   selhostelstudent() {
      this.fservice.selhostelstudent()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.studentarr = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }



    masbloodgroup() {
  this.fservice.masbloodgroups()
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.bloodgp = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

 sel_hosinstitute() {
  this.fservice.sel_hosinstitute()
      .subscribe(
      resultArray => {
          console.log('arrinst', resultArray);
          this.arrinst = resultArray;
          this.arrinsext=this.arrinst.filter(x=>x.intype=='E');
          this.arrinsinr=this.arrinst.filter(x=>x.intype!='E');
         this.masclid=this.arrinsinr[0].msclid;
      },
      error => console.log("Error :: " + error)
      )
}



savestudent(objstudent)
{
  debugger;
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
 
  console.log(objstudent);
  

  this.fservice.savehostelstudent(objstudent)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
// this.getstudents('s',0);


}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );

}



opencopymdl(content) {
  // console.log("formdata",formdata);
this.searchstudents(this.masclid,'');
 
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'xl'
   }

    if (this.modalService.hasOpenModals())
   {
    document.body.style.removeProperty('padding-right');
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
 
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
        //  this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
    
  
}

  searchstudents(masclid,srtxt) {
    debugger
    var pst1:any={};
    // pst1.srtxt=this.srtxt;
    pst1=this.arrinsinr.filter(x=>x.msclid==masclid)[0];
    
  var pst={srtxt:srtxt,msclid:pst1.msclid,intype:pst1.intype};
      this.fservice.getstudentsfromotherinstitute(pst)
          .subscribe(
          resultArray => {
              console.log('serstudent', resultArray);
              this.arrcourse = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }


     copystudatatohostel(obj) {
    debugger
    // var pst1:any={};
    // pst1.srtxt=this.srtxt;
    // pst1=this.arrinsinr.filter(x=>x.msclid==masclid)[0];
    
  // var pst={srtxt:this.srtxt,msclid:pst1.msclid,intype:pst1.intype};
      this.fservice.copystudatatohostel(obj)
          .subscribe(
          resultArray => {
              console.log('serstudent', resultArray);
              // this.arrcourse = resultArray;
              alert(resultArray.message);
              this.searchstudents(this.masclid,this.srtxt);
             
          },
          error => console.log("Error :: " + error)
          )
    }

}
